import "./InventoryScaling.css";
import { FiArrowUpRight } from "react-icons/fi";
import { motion } from "framer-motion";
import { ArrowUpOutlined } from "@ant-design/icons";

const cards: string[] = [
  "Lean inventory. Maximum output.",
  "Simplified stock. Stronger growth.",
  "Real-time control. Limitless potential.",
  "Track better. Grow quicker.",
  "Fewer errors. Bigger scale.",
  "Inventory clarity. Business agility.",
  "Smart systems. Scalable success.",
  "Instant insights. Smarter moves.",
  "Organize profits.",
  "One system. Endless efficiency.",
  "Simplified stock. Stronger growth.",
  "Track better. Grow quicker.",
  "Inventory clarity. Business agility.",
];

// Utility to split array into rows
const splitIntoRows = (arr: string[], rowCount: number = 3): string[][] => {
  const perRow = Math.ceil(arr.length / rowCount);
  return Array.from({ length: rowCount }, (_, row) =>
    arr.slice(row * perRow, (row + 1) * perRow)
  );
};

const InventoryScaling: React.FC = () => {
  const rows = splitIntoRows(cards, 3);

  return (
    <div className="inventorySection px-2 md:py-10 py-6">
      <div className="inventoryHeader">
        <h3 className="md:text-[27px] sm:text-[22px]">
          Smarter inventory. Faster scaling
        </h3>
        <p className="text-[16px]">
          Gain real-time visibility, automate stock management, and unlock growth potential.
        </p>
      </div>

      <div className="marquee-container">
        {rows.map((rowCards, rowIndex) => {
          const reverse = rowIndex % 2 === 1;
          const duplicatedCards = [...rowCards, ...rowCards];
          const cardWidth = 260;
          const gapWidth = 16;
          const totalWidthOfOneSet = rowCards.length * (cardWidth + gapWidth);

          return (
            <div className="marquee-row" key={rowIndex}>
              <motion.div
                className="marquee-track"
                animate={{
                  x: reverse
                    ? [`-${totalWidthOfOneSet}px`, `0px`]
                    : [`0px`, `-${totalWidthOfOneSet}px`],
                }}
                transition={{
                  repeat: Infinity,
                  repeatType: "loop",
                  ease: "linear",
                  duration: 15 + rowCards.length * 0.5,
                }}
                style={{ width: `${totalWidthOfOneSet * 2}px` }}
              >
                {[...duplicatedCards, ...duplicatedCards, ...duplicatedCards].map((text, i) => (
                  <div className="inventory-card" key={`${rowIndex}-${i}`}>
                    <span>{text}</span>
                    <ArrowUpOutlined className="arrow-icon" />
                  </div>
                ))}
              </motion.div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InventoryScaling;
